import axios from 'axios';

// Enhanced environment detection and API configuration
const getApiConfiguration = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isProduction = process.env.NODE_ENV === 'production';
  const reactAppEnv = process.env.REACT_APP_ENV;
  
  // API URL configuration - prioritize REACT_APP_API_URL from environment files
  let apiUrl = process.env.REACT_APP_API_URL;
  
  // Fallback for development if no environment variable is set
  if (!apiUrl) {
    if (isDevelopment || reactAppEnv === 'local') {
      apiUrl = 'http://localhost:5001';
    } else {
      // Production fallback - should be set in environment files
      console.warn('REACT_APP_API_URL not set in environment. Please configure it in your .env file.');
      apiUrl = 'http://localhost:5001'; // Safe fallback
    }
  }
  
  // Ensure the URL doesn't end with a slash to prevent double slashes
  apiUrl = apiUrl.replace(/\/$/, '');
  
  return {
    baseURL: apiUrl,
    environment: reactAppEnv || (isDevelopment ? 'local' : 'production'),
    isDevelopment,
    isProduction
  };
};

const config = getApiConfiguration();

console.log('API Configuration:', {
  baseURL: config.baseURL,
  environment: config.environment,
  isDevelopment: config.isDevelopment,
  isProduction: config.isProduction,
  envSource: process.env.REACT_APP_API_URL ? 'environment' : 'fallback'
});

const api = axios.create({
  baseURL: config.baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  // Add timeout for better error handling - increased for bulk operations
  timeout: 60000, // 60 seconds for bulk operations
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api; 